var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-toaster"},[_c('transition-group',{staticClass:"app-toaster__list",attrs:{"name":"toast","tag":"ol"}},_vm._l((_vm.toasts),function(toast){return _c('AppToast',_vm._b({key:toast.id,attrs:{"id":toast.id},on:{"close":_vm.remove,"pause":_vm.onPause,"resume":_vm.onResume}},'AppToast',toast,false))}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }